// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605120833/js/" + chunkId + "." + {"44":"976ce7ca","225":"2b5991b5","481":"3c27369a","486":"ca55a1cd","770":"e8105ca6"}[chunkId] + ".0.9737908747424753.chunk.js";
};